import { useState, useEffect } from "react";
import { FetchPlatforms } from "../../api/FetchPlatforms";

export interface dataType {
  meta: {
    page?: number;
    limit?: number;
    total?: number;
    current_page?: number;
    last_page?: number;
    first_page?: number;
    first_page_url?: string;
    last_page_url?: string;
    next_page_url?: string;
    previous_page_url?: any;
  };
  data: data[];
}

export interface data {
  data: {
    platform_name: string;
    created_by: any;
    created_at: any;
  };
}

const default_page_size = 10;

const _data: dataType = {
  meta: {
    page: 1,
    limit: default_page_size,
  },
  data: [],
};

export const useFetchPlatforms = (query: {
  page: number;
  limit: number;
  search_value?: string;
}) => {
  const [dataInfo, setDataInfo] = useState(_data);

  useEffect(() => {
    const fetchData = async () => {
      const result = await FetchPlatforms(query);

      if (result.data.data) {
        for (const item of result.data.data) {
          item["key"] = item.platform_id;
        }
      }

      setDataInfo(result);
    };

    fetchData();
  }, [query]);

  return dataInfo;
};
